import script from "./pay.vue?vue&type=script&setup=true&lang=js"
export * from "./pay.vue?vue&type=script&setup=true&lang=js"

import "./pay.vue?vue&type=style&index=0&id=3468cfa3&lang=scss"

const __exports__ = script;

export default __exports__